export type UserRights = {
  companyId: number;
  organizationId?: number;
  userId: number;
  permissions: UserRight[];
};

export type UserRight = {
  id: number;
  name: string;
};

/* export enum RoleName {
  SuperAdmin = "superadmin",
  Admin = "admin",
  Read = "read",
  Write = "write",
  ReportCreator = "reportcreartor",
  ReportReader = "reportreader",
} */

export enum RoleIdEnum {
  SuperAdmin = 94,
  Admin = 900,
  Read = 100,
  Write = 200,
  ReportReader = 300,
  ReportCreator = 400,
}

export type Permissions = {
  companyId: number;
  organizationId?: number;
  userId: number;
  permissions: { id: number; name: string }[];
};
